export default __webpack_public_path__ + "static/media/logoSmall.bfbbf196.png";